import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useGeneralStore from '../../../store/generalStore';
import { getchangeCall_AuditStatus } from '../../../API/agentApis';
import ContentLoader from '../../../Components/ContentLoader';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';

// Simple logger utility
const logger = {
  info: (message, data = {}) => console.log(`[INFO] ${message}`, data),
  error: (message, error = {}) => console.error(`[ERROR] ${message}`, error),
  warn: (message, data = {}) => console.warn(`[WARN] ${message}`, data)
};

const IntroductionRouter = () => {
  const audit_Call_step_count = useGeneralStore((state) => state.audit_Call_step_count);
  const setAuditCallStepCount = useGeneralStore((state) => state.setAuditCallStepCount);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();

  // Fetch audit status with error handling
  const fetchAuditStatus = async () => {
    try {
      setIsLoading(true);
      setError(null);
      logger.info('Fetching audit call status...');
      const data = await getchangeCall_AuditStatus();
      
      if (!data) {
        throw new Error('No data received from audit status API');
      }

      if (data.result === undefined) {
        throw new Error('Invalid response format: result field missing');
      }

      logger.info('Successfully fetched audit status', { stepCount: data.result });
      
      // If the user has already completed intro steps and needs to go to call audit
      if (data.result > 5) {
        // They've completed introduction, so redirect to call audit
        history.push('/agent/call_audited');
      } else {
        setAuditCallStepCount(data.result);
      }
    } catch (error) {
      logger.error('Failed to fetch audit call status', {
        message: error.message,
        stack: error.stack
      });
      setError('Failed to load introduction status. Please try again.');
      setAuditCallStepCount(1); // Fallback to step 1
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    logger.info('IntroductionRouter component mounted, initiating audit status fetch');
    fetchAuditStatus();
    
    return () => {
      logger.info('IntroductionRouter component unmounted');
    };
  }, []); // Empty dependency array as it only runs on mount

  // Render component based on step count
  const renderStepContent = () => {
    if (isLoading) {
      return <ContentLoader/>;
    }

    if (error) {
      return (
        <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
          {error}
          <button 
            onClick={fetchAuditStatus}
            style={{ marginTop: '10px', padding: '5px 10px' }}
          >
            Retry
          </button>
        </div>
      );
    }

    try {
      switch (audit_Call_step_count) {
        case 1:
          logger.info('Rendering Step 1 component - Tele-Collection Process');
          return <Step1 />;
        case 2:
          logger.info('Rendering Step 2 component - Agent Panel');
          return <Step2 />;
        case 3:
          logger.info('Rendering Step 3 component - Call Script');
          return <Step3 />;
        case 4:
          logger.info('Rendering Step 4 component - Live Call');
          return <Step4 />;
        case 5:
          logger.info('Rendering Step 5 component - Live Calls');
          return <Step5 />;
        default:
          // If the step count is 6 or higher, they should go to call audit
          history.push('/agent/call_audited');
          return null;
      }
    } catch (error) {
      logger.error('Error rendering step content', {
        message: error.message,
        stepCount: audit_Call_step_count
      });
      return (
        <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
          An error occurred while loading the content.
          <button 
            onClick={fetchAuditStatus}
            style={{ marginTop: '10px', padding: '5px 10px' }}
          >
            Retry
          </button>
        </div>
      );
    }
  };

  return (
    <>
      {renderStepContent()}
    </>
  );
};

export default IntroductionRouter; 